import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { AlertDialog } from "@toolpad/core";

export interface AlertDialogProps {
    title: string
    message: string
    onAddConfirmed: () => void
}

export const AddDialog: React.FC<AlertDialogProps> = (props: AlertDialogProps) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const confirm = () => {
    props.onAddConfirmed()
    setOpen(false);
  }

  return (
    <Box
      sx={{
        borderRadius: 2,
        display: 'inline-block',
        backgroundColor: '#fafafa',
        margin: 2,
      }}
    >
      <Button 
        aria-label="add" 
        variant="outlined"
        color="primary"
        onClick={handleClickOpen}>
          <AddIcon />
          {props.title}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {props.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={confirm} color="error" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}